import { render } from "./IdlingAgents.vue?vue&type=template&id=eb9aae88&scoped=true"
import script from "./IdlingAgents.vue?vue&type=script&lang=js"
export * from "./IdlingAgents.vue?vue&type=script&lang=js"

import "./IdlingAgents.vue?vue&type=style&index=0&id=eb9aae88&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb9aae88"]])

export default __exports__